// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BPb4","badges":"styles_badges__3CFhd"};